import { render, staticRenderFns } from "./Published.vue?vue&type=template&id=65f3543a&scoped=true&"
var script = {}
import style0 from "./Published.vue?vue&type=style&index=0&id=65f3543a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3543a",
  null
  
)

export default component.exports